/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpBetweenLines: {
  name: 'arrow-up-between-lines';
  data: string;
} = {
  name: 'arrow-up-between-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.707 3.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L11 6.414V20a1 1 0 1 0 2 0V6.414l1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3ZM6 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm11 17V4a1 1 0 1 1 2 0v16a1 1 0 1 1-2 0Z" fill="currentColor"/></svg>`,
};
